<script>

import useVuelidate from "@vuelidate/core";
import {helpers, required} from "@vuelidate/validators";
import Swal from "sweetalert2";
import moment from "moment";

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {

  },
  props: {
    prodClFiscaisList: {
      type: Array,
      default: function () {
        return [];
      },
    }
  },
  validations: {
    regSelecionado :{
      descricao: {
        required: helpers.withMessage("Campo descrição obrigatório, favor preencher.", required),
      },
      codigo: {
        required: helpers.withMessage("Campo código obrigatório, favor preencher.", required),
      },
      codred: {
        required: helpers.withMessage("Campo código reduzido obrigatório, favor preencher.", required),
      },
    }
  },
  mounted() {
    // console.log('mounted prodclFiscais-table_0')
    // console.log(this.updating)
  },
  methods: {

    nomeStatus(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },

    editar(dataID){
      console.log('editar: ' + dataID)
      this.showModal = true
      this.regSelecionado = this.prodClFiscaisList.find((reg) => reg.id === dataID);
      console.log('regSelecionado: ')
      console.log(this.regSelecionado)
    },

    deletar(dataID){
      console.log('deletar: ' + dataID)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.$emit('deletareg', dataID)
        }
      })
    },

    formSubmit() {
      console.log('formSubmit_0')
      this.submitted = true
      this.v$.$touch()
      if (this.v$.$invalid) {
        return;
      } else {
        console.log('formSubmit_validado')
        this.showModal = false
        this.$emit('alterareg', this.regSelecionado)
      }
    },

    setCriarNova: function() {
      this.regSelecionado = {}
      this.submitted = false
      this.showModal = true
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return 0.00;
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

  },
  data() {
    return {
      regSelecionado: {},
      submitted: false,
      showModal: false,
    };
  },
};
</script>

<template>
  <div class="table-responsive mb-0">
    <table class="table align-middle table-nowrap" v-if="prodClFiscaisList">
      <thead class="table-light">
      <tr>

        <th class="align-middle">ID</th>
        <th class="align-middle">Código</th>
        <th class="align-middle">Descrição</th>
        <th class="align-middle">Ações</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="data in prodClFiscaisList" :key="data.id">
        <td>
          <a href="javascript: void(0);"
             class="text-body fw-bold"
             @click="editar(data.id)">{{ data.id }}
          </a>
        </td>
        <td>{{ data.codigo }} </td>
        <td class="text-wrap" style="max-width: 50%;">{{ data.descricao }} </td>

        <td>
          <div class="button-items">
            <b-button variant="outline-success" @click="editar(data.id)">
              <i class="mdi mdi-pencil d-block font-size-16"></i>
            </b-button>
            <b-button variant="outline-danger" @click="deletar(data.id)">
              <i class="mdi mdi-trash-can d-block font-size-16"></i>
            </b-button>
          </div>
        </td>

      </tr>
      </tbody>
    </table>

    <b-modal :title="regSelecionado.id != null ? `Editar Classificação (${ regSelecionado.id })` : 'Criar Nova Classificaçaõ'" v-model="showModal" hide-footer>
      <form @submit.prevent="formSubmit">
        <div class="row">

          <div class="col-12">
            <div class="mb-3">
              <label for="descricao">Descrição</label>
              <input
                  id="descricao"
                  v-model="regSelecionado.descricao"
                  type="text"
                  class="form-control"
                  placeholder="Inserir descrição"
                  :class="{'is-invalid': submitted && v$.regSelecionado.descricao.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.descricao.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.descricao.required.$message">
                  {{ v$.regSelecionado.descricao.required.$message }}
                </span>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="mb-3">
              <label for="codigo">Código</label>
              <input
                  id="codigo"
                  v-model="regSelecionado.codigo"
                  type="text"
                  class="form-control"
                  placeholder="Inserir código"
                  :class="{'is-invalid': submitted && v$.regSelecionado.codigo.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.codigo.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.codigo.required.$message">
                  {{ v$.regSelecionado.codigo.required.$message }}
                </span>
              </div>
            </div>
          </div>


          <div class="col-6">
            <div class="mb-3">
              <label for="codred">Reduzido</label>
              <input
                  id="codred"
                  v-model="regSelecionado.codred"
                  type="text"
                  class="form-control"
                  placeholder="Inserir código reduzido"
                  :class="{'is-invalid': submitted && v$.regSelecionado.codred.$error,}"/>
              <div
                  v-if="submitted && v$.regSelecionado.codred.$error"
                  class="invalid-feedback">
                <span v-if="v$.regSelecionado.codred.required.$message">
                  {{ v$.regSelecionado.codred.required.$message }}
                </span>
              </div>
            </div>
          </div>

<!--          <div class="col-6">-->
<!--            <div class="mb-3">-->
<!--              <label for="selectStatus">Status</label>-->
<!--              <b-form-select-->
<!--                  id="selectStatus"-->
<!--                  v-model="regSelecionado.status"-->
<!--                  class="mb-3 form-select form-control"-->
<!--                  :class="{'is-invalid': submitted && v$.regSelecionado.status.$error,}">-->
<!--                <b-form-select-option value="A">-->
<!--                  Ativo-->
<!--                </b-form-select-option>-->
<!--                <b-form-select-option value="I">-->
<!--                  Inativo-->
<!--                </b-form-select-option>-->
<!--                <b-form-select-option value="L">-->
<!--                  Análise-->
<!--                </b-form-select-option>-->
<!--              </b-form-select>-->
<!--              <div v-if="submitted && v$.regSelecionado.status.$error" class="invalid-feedback">-->
<!--                <span v-if="v$.regSelecionado.status.required.$message">-->
<!--                  {{ v$.regSelecionado.status.required.$message }}-->
<!--                </span>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->

<!--          <div class="col-6">-->
<!--            <div class="mb-3">-->
<!--              <label for="desconto">Desconto de partida</label>-->
<!--              <input-->
<!--                  id="desconto"-->
<!--                  v-model="regSelecionado.desconto"-->
<!--                  type="number"-->
<!--                  class="form-control"-->
<!--                  placeholder="Desconto de partida"/>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="col-6">-->
<!--            <div class="mb-3">-->
<!--              <label for="qtditens">Quantidade mínima de itens</label>-->
<!--              <input-->
<!--                  id="qtditens"-->
<!--                  v-model="regSelecionado.qtditens"-->
<!--                  type="number"-->
<!--                  class="form-control"-->
<!--                  placeholder="Quantidade mínima de itens"/>-->
<!--            </div>-->
<!--          </div>-->

<!--          <div class="col-6">-->
<!--            <div class="mb-3">-->
<!--              <label for="valormin">Valor mínimo</label>-->
<!--              <input-->
<!--                  id="valormin"-->
<!--                  v-model="regSelecionado.valormin"-->
<!--                  type="number"-->
<!--                  class="form-control"-->
<!--                  placeholder="Valor mínimo"/>-->
<!--            </div>-->
<!--          </div>-->

        </div>

        <div class="text-end mt-3">
          <b-button variant="light" @click="showModal = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Fechar
          </b-button>
          <b-button variant="success" class="ms-1" @click="formSubmit">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </form>

    </b-modal>
  </div>

</template>
